import { SearchBar, Dropdown, CardContainer } from 'finara-components';
import React, { useState } from 'react';

import { clientStatusOptions, clientTypeOptions } from '../../../data/super-admin/clients';

interface ClientSearchFiltersProps {
  onSearch: (query: string) => void;
  onStatusFilter: (status: string) => void;
  onTypeFilter: (type: string) => void;
}

export const ClientSearchFilters: React.FC<ClientSearchFiltersProps> = ({
  onSearch,
  onStatusFilter,
  onTypeFilter,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedStatus, setSelectedStatus] = useState('all');
  const [selectedType, setSelectedType] = useState('all');

  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
    onSearch(query);
  };

  const handleStatusChange = (value: string | number) => {
    const status = String(value);
    setSelectedStatus(status);
    onStatusFilter(status);
  };

  const handleTypeChange = (value: string | number) => {
    const type = String(value);
    setSelectedType(type);
    onTypeFilter(type);
  };

  return (
    <CardContainer>
      <div className="flex flex-col md:!flex-row items-center gap-4">
        {/* Search Bar */}
        <div className="w-full md:flex-1">
          <SearchBar
            className="w-full"
            placeholder="Buscar por nombre o RFC..."
            value={searchQuery}
            onChange={handleSearchChange}
          />
        </div>

        {/* Status Filter */}
        <Dropdown
          className="w-full md:!w-auto"
          options={clientStatusOptions}
          value={selectedStatus}
          onChange={handleStatusChange}
          placeholder="Todos los estatus"
        />

        {/* Type Filter */}
        <Dropdown
          className="w-full md:!w-auto"
          options={clientTypeOptions}
          value={selectedType}
          onChange={handleTypeChange}
          placeholder="Todos los tipos"
        />
      </div>
    </CardContainer>
  );
};
